<template>
  <div class="margin-bottom-s margin-top-s text-center">
    <p v-if="hideText" class="text-center margin-bottom-xs barcode-text medium">
      <span v-html="barcodeText"></span>
    </p>
    <div v-if="isBarcodeImageLoading" class="grid-x align-center margin-bottom-xs">
      <AtomicUiSkeleton height="100px" width="200px" />
    </div>

    <img v-else id="barcode-image" class="margin-bottom-xs" alt="Barcode" :src="fetchBarCodeImage" />
    <div id="barcode-number" v-text="barcodeNumber"></div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { giftGiverRegistryView, manageRegistry, babyRegistryConfig } from 'config';
import { GET_BAR_CODE_IMAGE } from '~/types/actions';
import { useBarcodeStore } from '~/stores/barcode';

const props = defineProps({
  barcodeNumber: {
    type: String,
    default: '',
    required: true,
  },
  hideText: {
    type: Boolean,
    default: true,
  },
  isRegistrant: {
    type: Boolean,
    default: false,
    required: false,
  },
  isBabyRegistry: {
    type: Boolean,
    default: false,
    required: false,
  },
});
const barcodeStore = useBarcodeStore();

const isBarcodeImageLoading = ref(true);
const fetchBarCodeImage = computed(() => barcodeStore?.barcodeImage?.data);
const barcodeText = computed(() => {
  if (props.isBabyRegistry && props.isRegistrant) {
    return babyRegistryConfig.manageRegistry.barcodeInstructionsMyGifts;
  }
  if (props.isBabyRegistry && !props.isRegistrant) {
    return babyRegistryConfig.giftGiverRegistryView.barcodeInstructions;
  }
  if (!props.isBabyRegistry && props.isRegistrant) {
    return manageRegistry.barcodeInstructionsMyGifts;
  }
  return giftGiverRegistryView.barcodeInstructions;
});
const getBarCodeImage = async () => {
  isBarcodeImageLoading.value = true;

  await barcodeStore[GET_BAR_CODE_IMAGE]({
    barCode: props.barcodeNumber,
  });

  isBarcodeImageLoading.value = false;
};

onMounted(() => {
  getBarCodeImage();
});
</script>

<style lang="scss" scoped>
#barcode-image {
  width: rem-calc(200);
  height: rem-calc(100);
}
</style>
